<template lang="pug">
transition(name="fade")
  .menu-window(v-if="isShowMenu" @touchmove="onTouchMove")
    .background
    .menu-content
      ul
        li(v-for="(item, i) in viewList" @click="onSelect(item)") {{menuNames[i]}}
</template>

<script>
import { mapState, mapMutations,  mapGetters } from 'Vuex'

export default {
  props:{},
  components: {},
  computed: {
     ...mapState('menu', {isShowMenu: 'isShow'}),
     ...mapGetters('debug', ['viewList', 'menuNames']),
  },    
  methods: {
    ...mapMutations('menu', {hideMenu: 'hide'}),
   onTouchMove(e){
      e.preventDefault();
    },
    async onSelect(name){
      this.hideMenu();
      await this.$viewer.changeScene(name);
    }
  },
  created () {
    
  },
  mounted () {
    
  },
  data () {
    return {
    }
  },
}
</script>

<style lang="stylus" scoped>
.fade
  &-enter-active,
  &-leave-active
    transition opacity 0.3s ease;
  &-enter,
  &-leave-to
    opacity 0;
.menu-window
  position fixed
  top 0
  left 0
  z-index 200
  width 100%
  height 100%
  .background
    width 100%
    height 100%
    background-color rgba(0, 0, 0, 1)
    position absolute
    top 0
    left 0
    z-index 0
  .menu-content
    padding-top 50px
    width 100%
    position relative
    z-index 1
    ul
      text-align center 
      li
        margin-top 10px
        font-size 20px
        color white
        width 100%
        height 50px
        line-height 50px
        cursor pointer
      li:hover
        background #fff
        color #000

</style>
